import { JsonObject, JsonProperty } from 'json2typescript';

import { PBCAliasInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('PBCAlias')
export class PBCAlias implements PBCAliasInterface {
    @JsonProperty('nombre', StringAdapter)
    private _name: string = undefined;

    @JsonProperty('tipo', StringAdapter)
    private _type: string = undefined;

    @JsonProperty('comentario', StringAdapter, true)
    private _comment?: string = undefined;

    get name(): string {
        return this._name;
    }

    get type(): string {
        return this._type;
    }

    get comment(): string {
        return this._comment;
    }
}
